import axios from "axios";

const axiosClient = axios.create({
  // baseURL: "http://localhost:6003",
  baseURL: "https://api-pay.edu-action.uk",
});

axiosClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response.status === 403) {
      localStorage.removeItem("token");
      window.location.href = "/login";
    }
    throw error;
  }
);

export default axiosClient;
